export const getTimeDiff = (date: string) => Math.abs(new Date(date).getTime() - Date.now());
